var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.view && (_vm.view['hydra:next']))?_c('div',{staticClass:"text-center mb-3"},[_c('button',{staticClass:"btn btn-circle btn-primary btn-lg",attrs:{"type":"button","disabled":!_vm.view['hydra:next']},on:{"click":function($event){_vm.getPage(_vm.view['hydra:next'])}}},[_c('font-awesome-icon',{attrs:{"icon":"angle-down"}})],1)]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d6e4053a","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/post/ShowMorePage.vue
// module id = 1041
// module chunks = 0